import type { PropsWithChildren } from "react";
import { useEffect } from "react";
import { useScrollDirection } from "~/lib/hooks/useScrollDirection";
import { useSessionStore } from "~/lib/stateManagement/sessionState/sessionStore";

export const ScrollManager = ({ children }: PropsWithChildren) => {
	const { scrollDirection } = useScrollDirection();
	const atTop = useSessionStore((store) => store.atTop);

	useEffect(() => {
		if (scrollDirection === "up" || atTop) {
			document.body.classList.add("header-visible");
			return;
		}
		if (scrollDirection === "down" && !atTop) {
			document.body.classList.remove("header-visible");
			return;
		}
	}, [scrollDirection, atTop]);

	return <>{children}</>;
};
